import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_preview-faires_arrangement_link-click';

/**
 * Tracks clicks on cta to Faire&#39;s Arrangement loom video
 */
export function trackBrandPreviewFairesArrangementLinkClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
